import { Vector2 } from 'three'

type DragHandlers = {
  onClick?: (event: MouseEvent) => void
  onDoubleClick?: (event: MouseEvent) => void
  onRightClick?: (event: MouseEvent) => void
  onDragStart?: (event: MouseEvent) => void
  onDragEnd?: (event: MouseEvent) => void
  onPointerMove?: (event: MouseEvent) => void
}

const useMouseEvents = (handlers: DragHandlers) => {
  let mouseDownPosition: Vector2 | null = null
  let isDragging = false

  function onContextMenu(event: MouseEvent) {
    handlers.onRightClick?.(event)
  }

  function onDblClick(event: MouseEvent) {
    handlers.onDoubleClick?.(event)
  }

  function onMouseDown(event: MouseEvent) {
    // Only track left mouse button (button === 0)
    if (event.button === 0) {
      mouseDownPosition = new Vector2(event.clientX, event.clientY)
      isDragging = false
    }
  }

  function onMouseMove(event: MouseEvent) {
    if (!mouseDownPosition) return
    const dx = event.clientX - mouseDownPosition.x
    const dy = event.clientY - mouseDownPosition.y
    const distance = Math.hypot(dx, dy)
    const threshold = 5

    if (distance > threshold && !isDragging) {
      isDragging = true
      handlers.onDragStart?.(event)
    }
  }

  function onMouseUp(event: MouseEvent) {
    // Only handle left mouse button clicks
    if (event.button === 0) {
      if (isDragging) {
        handlers.onDragEnd?.(event)
      }
      else {
        handlers.onClick?.(event)
      }
      isDragging = false
      mouseDownPosition = null
    }
  }

  function onPointerMove(event: MouseEvent) {
    handlers?.onPointerMove?.(event)
  }

  globalThis.addEventListener('contextmenu', onContextMenu)
  globalThis.addEventListener('dblclick', onDblClick)
  globalThis.addEventListener('mousedown', onMouseDown)
  globalThis.addEventListener('mousemove', onMouseMove)
  globalThis.addEventListener('mouseup', onMouseUp)
  globalThis.addEventListener('pointermove', onPointerMove)

  return () => {
    globalThis.removeEventListener('contextmenu', onContextMenu)
    globalThis.removeEventListener('dblclick', onDblClick)
    globalThis.removeEventListener('mousedown', onMouseDown)
    globalThis.removeEventListener('mousemove', onMouseMove)
    globalThis.removeEventListener('mouseup', onMouseUp)
    globalThis.removeEventListener('pointermove', onPointerMove)
  }
}

export default useMouseEvents
